(function () {
  const slideshow = () => {
    $(".slideshow-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return;
      }

      $(this).addClass("slider_started");

      const id = $(this).attr("id");
      const box = $(this).find(".slideshow");

      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const source = box.data("source");

      let autoplayParm = {};

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      }

      const swiperEl = document.querySelector(
        `#${id} .slideshow__swiper`
      );

      if (!swiperEl) {
        return;
      }

      /*
       * FULL RANDOM SHUFFLE
       * Only applies to collection-based slides.
       * Manual slides stay in their original order.
       */
      if (source === "collection") {
        const wrapper = swiperEl.querySelector(
          ".swiper-wrapper"
        );

        if (wrapper) {
          const slides = Array.from(
            wrapper.querySelectorAll(
              ":scope > .swiper-slide"
            )
          );

          /*
           * Fisher-Yates shuffle
           */
          for (
            let i = slides.length - 1;
            i > 0;
            i--
          ) {
            const j = Math.floor(
              Math.random() * (i + 1)
            );

            [slides[i], slides[j]] = [
              slides[j],
              slides[i],
            ];
          }

          /*
           * Re-append slides in shuffled order
           */
          slides.forEach((slide) => {
            wrapper.appendChild(slide);
          });
        }
      }

      const slideCount =
        swiperEl.querySelectorAll(
          ".swiper-slide"
        ).length;

      const swiperParms = {
        parallax: box.data("parallax"),
        speed: box.data("speed") * 1000,
        effect: box.data("effect"),

        loop: slideCount > 1,
        centeredSlides: false,
        autoHeight: false,
        calculateHeight: false,
        keyboard: true,

        creativeEffect: {
          prev: {
            shadow: true,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },

        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },

        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },

        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },

        ...autoplayParm,
      };

      const swiper = new Swiper(
        swiperEl,
        swiperParms
      );

      requestAnimationFrame(() => {
        colorScheme(swiper);
      });

      swiper.on(
        "beforeTransitionStart",
        function () {
          colorScheme(this);
        }
      );

      function colorScheme(context) {
        const activeSlide =
          context.slides[
            context.activeIndex
          ];

        if (!activeSlide) {
          return;
        }

        const changeItems = [
          context.navigation &&
            context.navigation.nextEl,

          context.navigation &&
            context.navigation.prevEl,

          context.pagination &&
            context.pagination.el,
        ];

        const slideColorScheme = $(
          activeSlide
        )
          .find(".slideshow-slide")
          .data("color-scheme");

        if (!slideColorScheme) {
          return;
        }

        changeItems.forEach((item) => {
          if (!item) {
            return;
          }

          $(item)
            .removeClass(
              "color-background-1"
            )
            .removeClass(
              "color-background-4"
            )
            .addClass(
              slideColorScheme
            );
        });
      }
    });
  };

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      slideshow();

      document.addEventListener(
        "shopify:section:load",
        function () {
          slideshow();
        }
      );
    }
  );
})();